(function() {
    'use strict';

    /******************************************
     * Copy text between category type testers
     *
     ******************************************/
    let copyTextButtons = document.querySelectorAll('[data-copy-text]');

    if (copyTextButtons) {
        document.addEventListener('click', function(ev) {
            if (ev.target.matches('[data-copy-text]')) {
                ev.preventDefault();
                ev.stopPropagation();

                let textToCopy = ev.target.closest('[data-font]').querySelector('[data-type-tester-editable-content] span').innerText;

                if (textToCopy) {
                    let typeTesterTextContainers = document.querySelectorAll('[data-type-tester-editable-content] span');

                    if (typeTesterTextContainers) {
                        Array.prototype.forEach.call(typeTesterTextContainers, function(el) {
                            el.innerText = textToCopy;
                        });
                    }
                }
            }
        });
    }
})();

